window._pcq = window._pcq || [];

//registers callback function to be called when user gets successfully subscribed
_pcq.push(['subscriptionSuccessCallback',callbackFunctionOnSuccessfulSubscription]);

//Calls triggerOptIn with segment
window._pcq.push(['triggerOptIn',{subscriberSegment: 'elektrinacz'}]);

function callbackFunctionOnSuccessfulSubscription(subscriberId, values) {
    console.log('User got successfully subscribed.');
}


// WEBPACK FOOTER //
// ./app/Resources/assets/js/scripts/pushNotification.js